'use client'

import React, { useState } from 'react'
import { NavbarItem } from './navbar'
import { colors, semanticColors } from '../theme'

// Custom color palette for sidebar
const sidebarColors = {
  primary: "#2A333C",
  primaryLight: "#677D94",
  primaryDark: "#1A2128",
  secondary: "#F5B957",
  secondaryLight: "#FCECD1",
  secondaryDark: "#AB6D0A",
  conPrimary: "#1F2937",
  iconSecondary: "#7A6646",
  iconTertiary: "#94A3B8",
  iconFourth: "#CBD5E1",
  iconInverted: "#FFFFFF",
  badgePrimary: "#FF6B6B",
  green100: "#E0EDE2",
  green600: "#3A7D44",
  green800: "#2E6B3A",
  blue100: "#E0E8ED",
  blue500: "#4A6FA5",
  blue700: "#3A5F7D",
  blue800: "#2A4A6C",
  blue900: "#1A334C",
  blue600: "#3A5F7D",
  yellow100: "#FFF8E6",
  yellow800: "#D4A123",
  red100: "#FFEAEA",
  red500: "#C84648",
  red700: "#A23537",
  red900: "#7A2527",
  orange50: "#FFF5EB",
  orange100: "#FCE8D9",
  orange500: "#E67E34",
  orange700: "#C4450D",
  orange800: "#BF5A1F",
  card1: "#F8FAFC",
}

function OpenMenuIcon() {
  return (
    <svg 
      className="size-6" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      aria-hidden="true"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" 
      />
    </svg>
  )
}

function CloseMenuIcon() {
  return (
    <svg 
      className="size-6" 
      fill="none" 
      viewBox="0 0 24 24" 
      strokeWidth="1.5" 
      stroke="currentColor" 
      aria-hidden="true"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M6 18L18 6M6 6l12 12" 
      />
    </svg>
  )
}

export function SidebarLayout({
  sidebar,
  children,
}: React.PropsWithChildren<{ sidebar: React.ReactNode }>) {
  return (
    <div 
      className="relative isolate flex w-full"
      style={{ backgroundColor: semanticColors.background.primary }}
    >
      <div
        className="z-50 flex w-38 max-w-[78vw] flex-col overflow-y-auto px-3 pb-4 pt-4 shadow-2xl sm:w-40 md:w-48 lg:w-60"
        style={{ 
          background: `linear-gradient(180deg, ${sidebarColors.primary} 0%, ${sidebarColors.primaryDark} 100%)`,
          borderRight: `1px solid ${sidebarColors.primaryLight}30`,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
        }}
      >
        {sidebar}
      </div>

      {/* Main content area - no header, just content - Compact */}
      <div className="flex flex-1 flex-col">
        <main className="flex-1">
          <div className="px-4 py-6 sm:px-6 sm:py-8 lg:px-6 lg:py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}